import buildingHero from '@/assets/img/home-redesign/hero-building.jpg'
import buildingAbout from '@/assets/img/home-redesign/about-building.jpg'
import aboutVideo from '@/assets/video/index.mp4'
import imgPregnancy from '@/assets/img/section3-index.png'
import imgBirth from '@/assets/img/section4-index.png'
import imgEco from '@/assets/img/section5-index.png'
import imgNewborn from '@/assets/img/section7-index.png'
import imgReviewSide from '@/assets/img/gallery-chambers/1.jpg'
import imgNews1 from '@/assets/img/news.png'
import imgNews2 from '@/assets/img/education.jpg'
import imgNews3 from '@/assets/img/room1.jpg'
import logoSvg from '@/assets/svg/logo.svg'
import iconDoctor from '@/assets/img/home-redesign/icon-doctor.png'
import iconPregnancy from '@/assets/img/home-redesign/icon-pregnancy.png'
import iconReviews from '@/assets/img/home-redesign/icon-reviews.png'
import iconPrice from '@/assets/img/home-redesign/icon-price.png'
import iconLab from '@/assets/img/home-redesign/icon-lab.png'
import iconMother from '@/assets/img/home-redesign/icon-mother.png'
import iconLike from '@/assets/img/home-redesign/icon-like.png'
import iconPeople from '@/assets/img/home-redesign/icon-people.png'
import iconHeart from '@/assets/img/home-redesign/icon-heart.png'
import quickRody from '@/assets/img/home-redesign/quick-rody.png'
import quickEco from '@/assets/img/home-redesign/quick-eco.png'
import quickSpecialists from '@/assets/img/home-redesign/quick-specialists.png'
import quickPrice from '@/assets/img/home-redesign/quick-price.png'
import quickReviews from '@/assets/img/home-redesign/quick-reviews.png'
import advExperience from '@/assets/img/home-redesign/adv-experience.png'
import advEquipment from '@/assets/img/home-redesign/adv-equipment.png'
import advIndividual from '@/assets/img/home-redesign/adv-individual.png'
import advComfort from '@/assets/img/home-redesign/adv-comfort.png'

export const icons = {
  doctor: iconDoctor,
  pregnancy: iconPregnancy,
  reviews: iconReviews,
  price: iconPrice,
  lab: iconLab,
  mother: iconMother,
  like: iconLike,
  people: iconPeople,
  heart: iconHeart,
}

export const contacts = {
  address: 'г. Барнаул, ул. Сергея Семёнова, 6',
  scheduleWeek: 'Пн–Пт 8:00–20:00',
  scheduleWeekend: 'Сб–Вс 9:00–15:00',
  phone: '+7 (3852) 50-60-20',
  phoneHref: 'tel:+73852506020',
  email: 'info@perinataldar.ru',
  callbackLabel: 'Перезвоните мне',
  callbackTo: '/appeal',
  bookLabel: 'Запись онлайн',
  bookTo: '/paid-services',
}

export const brand = {
  logo: logoSvg,
  line: 'Перинатальный центр',
  name: 'ДАР',
  tagline: 'Забота о маме и малыше с первого дня и на протяжении всего пути.',
}

export const navItems = [
  { label: 'О центре', to: '/about' },
  { label: 'Направления', to: '/services' },
  { label: 'Специалисты', to: '/about/specialists' },
  { label: 'Цены', to: '/paid-services' },
  { label: 'Акции', to: '/about' },
  { label: 'Новости', to: '/about/news' },
  { label: 'Отзывы', to: '/about/reviews' },
  { label: 'Контакты', to: '/about/contacts' },
]

export const hero = {
  eyebrow: 'Забота с первого дня',
  titleLine1: 'Перинатальный центр',
  titleBrand: 'ДАР',
  description: 'КГБУЗ\u00A0"Алтайский\u00A0краевой\u00A0клинический\u00A0перинатальный\u00A0центр"',
  image: buildingHero,
  imageAlt: 'Здание перинатального центра ДАР',
  actions: [
    { label: 'Контакты', to: '/about/contacts', primary: false, icon: 'pin' },
  ],
}

export const quickLinks = [
  { label: 'Роды', to: '/rody1', iconImage: quickRody },
  { label: 'ЭКО', to: '/family-center2', iconImage: quickEco },
  { label: 'Специалисты', to: '/about/specialists', iconImage: quickSpecialists },
  { label: 'Прайс-лист', to: '/paid-services', iconImage: quickPrice },
  { label: 'Отзывы', to: '/about/reviews', iconImage: quickReviews },
]

export const about = {
  title: 'О перинатальном центре',
  image: buildingAbout,
  imageAlt: 'Перинатальный центр ДАР',
  video: aboutVideo,
  paragraphs: [
    'КГБУЗ „Алтайский краевой клинический перинатальный центр „ДАР““ — современное многопрофильное учреждение для оказания медицинской помощи женщинам и детям.',
    'Мы объединяем передовые технологии, опытных специалистов и искреннюю заботу, чтобы каждое рождение было в надёжных руках.',
  ],
  moreLabel: 'Подробнее о центре',
  moreTo: '/about',
}

export const stats = [
  { value: '—', label: 'Родов с момента открытия', iconImage: iconPeople, field: 'countOpen' },
  { value: '—', label: 'Родов с начала года', iconImage: iconMother, field: 'countStartYear' },
  { value: '—', label: 'Родов за сутки', iconImage: iconHeart, field: 'countDay' },
  {
    value: '—',
    label: 'Оценка по данным 2ГИС',
    iconImage: iconLike,
    kind: 'rating2gis',
  },
]

export const directions = [
  {
    title: 'Ведение беременности',
    description:
      'Наблюдение опытных акушеров-гинекологов на всех сроках. Современная диагностика и индивидуальный подход.',
    points: [
      'Планирование и наблюдение',
      'Скрининги и УЗИ',
      'Консультации специалистов',
      'Школа для будущих мам',
    ],
    image: imgPregnancy,
    imageAlt: 'Ведение беременности',
    imageLeft: true,
    moreTo: '/pregnancy2',
  },
  {
    title: 'Роды',
    description: 'Безопасные роды в комфортных условиях с заботой 24/7.',
    points: [
      'Индивидуальный родовой зал',
      'Партнёрские роды',
      'Эпидуральная анестезия',
      'Непрерывное наблюдение',
    ],
    image: imgBirth,
    imageAlt: 'Роды',
    imageLeft: false,
    moreTo: '/rody1',
  },
  {
    title: 'ЭКО',
    description:
      'Программы вспомогательных репродуктивных технологий с доказанной эффективностью.',
    points: [
      'Опытные репродуктологи',
      'Современная лаборатория',
      'Индивидуальные протоколы',
      'Поддержка на всех этапах',
    ],
    image: imgEco,
    imageAlt: 'ЭКО',
    imageLeft: true,
    moreTo: '/family-center2',
  },
  {
    title: 'Плод и новорождённый',
    description: 'Высокотехнологичная помощь маме и малышу с первых минут жизни.',
    points: [
      'Неонатология',
      'Реанимация и интенсивная терапия',
      'Консультации специалистов',
      'Вакцинация и наблюдение',
    ],
    image: imgNewborn,
    imageAlt: 'Плод и новорождённый',
    imageLeft: false,
    moreTo: '/newborn_new',
  },
]

export const review = {
  title: 'Отзывы о нашей работе',
  name: 'Анастасия К.',
  date: '12 мая 2026',
  text:
    'Очень благодарна врачам и всему персоналу центра. Чувствовали заботу на каждом этапе — от наблюдения до выписки. Рекомендую всем будущим мамам!',
  rating: 5,
  ratingLabel: '5,0',
  sideImage: imgReviewSide,
  sideImageAlt: 'Забота о малыше',
  allLabel: 'Смотреть все отзывы',
  allTo: '/about/reviews',
  iconImage: iconReviews,
}

export const newsBlock = {
  title: 'Новости центра',
  allLabel: 'Все новости →',
  allTo: '/about/news',
  items: [
    {
      title: 'День открытых дверей для будущих родителей',
      date: '5 мая 2026',
      description: 'Экскурсия по отделениям, знакомство со специалистами и ответы на вопросы.',
      image: imgNews1,
      to: '/about/news',
    },
    {
      title: 'Новая услуга: расширенный неонатальный скрининг',
      date: '28 апреля 2026',
      description: 'Расширенная диагностика помогает вовремя выявить риски для здоровья малыша.',
      image: imgNews2,
      to: '/about/news',
    },
    {
      title: 'Школа мам: расписание на май',
      date: '20 апреля 2026',
      description: 'Практические занятия по уходу за новорождённым и подготовке к родам.',
      image: imgNews3,
      to: '/about/news',
    },
  ],
}

export const advantages = [
  {
    title: 'Опыт и профессионализм',
    text: 'Команда экспертов с большим опытом работы',
    iconImage: advExperience,
  },
  {
    title: 'Современное оборудование',
    text: 'Точность диагностики и безопасность лечения',
    iconImage: advEquipment,
  },
  {
    title: 'Индивидуальный подход',
    text: 'Забота и внимание к каждой пациентке',
    iconImage: advIndividual,
  },
  {
    title: 'Комфорт и забота',
    text: 'Уютные палаты и поддержка на всех этапах',
    iconImage: advComfort,
  },
]

export const footerColumns = [
  {
    title: 'Контакты',
    type: 'contacts',
  },
  {
    title: 'Пациентам',
    links: [
      { label: 'Как к нам проехать', to: '/about/contacts' },
      { label: 'Подготовка к анализам', to: '/tests2' },
      { label: 'Страхование', to: '/oms2' },
    ],
  },
  {
    title: 'Услуги',
    links: [
      { label: 'Ведение беременности', to: '/pregnancy2' },
      { label: 'Роды', to: '/rody1' },
      { label: 'ЭКО', to: '/family-center2' },
      { label: 'Плод и новорождённый', to: '/newborn_new' },
      { label: 'Платные услуги', to: '/paid-services' },
    ],
  },
  {
    title: 'О центре',
    links: [
      { label: 'О центре', to: '/about' },
      { label: 'Специалисты', to: '/about/specialists' },
      { label: 'Цены', to: '/paid-services' },
      { label: 'Акции', to: '/about' },
      { label: 'Отзывы', to: '/about/reviews' },
      { label: 'Контакты', to: '/about/contacts' },
    ],
  },
]

export const footerMeta = {
  copyright: '© КГБУЗ «АККПЦ „ДАР“», 2026',
  privacy: { label: 'Политика конфиденциальности', to: '/about/privacy-policy' },
  credits: { label: 'Разработка сайта', href: '#' },
  a11yLabel: 'Версия для слабовидящих',
  socials: [
    { label: 'ВКонтакте', href: 'https://vk.com/', icon: 'vk' },
    { label: 'Telegram', href: 'https://t.me/', icon: 'tg' },
    { label: 'WhatsApp', href: 'https://wa.me/', icon: 'wa' },
    { label: 'Одноклассники', href: 'https://ok.ru/', icon: 'ok' },
  ],
}
